const searchableDomains = ['taobao.com', 'tmall.com', 'tb.cn', '1688.com', 'weidian.com'];

export function isCompleteProductLink(value) {
  return /^https?:\/\//i.test(String(value || '').trim());
}

export function getExpertPurchaseFallbackLink(input, result) {
  if (isCompleteProductLink(input)) return String(input).trim();
  // Share text is not itself a complete link. Prefer the resolver's extracted
  // original URL, followed by its resolved destinations.
  for (const value of [result?.extractedUrl, result?.finalUrl, result?.matchedUrl]) {
    const text = typeof value === 'string' ? value.trim() : '';
    const markdownLink = /^\[[\s\S]*?\]\((https?:\/\/[\s\S]+)\)$/i.exec(text);
    const link = markdownLink ? markdownLink[1] : text;
    if (isCompleteProductLink(link)) return link;
  }
  return '';
}

export function shouldUseExpertPurchase(value) {
  if (!isCompleteProductLink(value)) return false;
  try {
    const { hostname } = new URL(String(value).trim());
    return !searchableDomains.some(domain => hostname === domain || hostname.endsWith(`.${domain}`));
  } catch {
    // Completeness is defined by the HTTP(S) prefix, not URL validation.
    return true;
  }
}

export function buildExpertPurchaseSearchPath(value) {
  const query = new URLSearchParams({
    itemLink: String(value || '').trim(),
    searchFallback: '1',
  });
  return `/shop/expertPurchaseHome?${query.toString()}`;
}
